import { useMemo } from "react";
import TooltipComponent from "./TooltipComponent";
import React from "react";

const TextBox = (props) => {
  return (
    <div>
      <label htmlFor="basiInput" className="form-label">
        {props.label}
      </label>
      <input
        className="form-control"
        value={props.value}
        type={props.type}
        id={props.id}
        name={props.name}
        placeholder={props.hint}
        onChange={props.change}
        required={true}
      />
    </div>
  );
};

const TextArea = (props) => {
  return (
    <div>
      <label htmlFor="basiInput" className="form-label">
        {props.label}
      </label>
      <textarea
        className="form-control"
        value={props.value}
        type={props.type}
        id={props.id}
        name={props.name}
        placeholder={props.hint}
        onChange={props.change}
        required={true}
      />
    </div>
  );
};
const SubmitBtn = (props) => {
  return props.status === true ? (
    <button type="button" class={`btn btn-${props.type} btn-load`}>
      <span class="d-flex align-items-center">
        <span class="flex-grow-1 me-2">Please wait...</span>
        <span class="spinner-grow flex-shrink-0" role="status">
          <span class="visually-hidden">Please wait...</span>
        </span>
      </span>
    </button>
  ) : (
    <button
      type="submit"
      className={`btn btn-${props.type} btn-label waves-effect right waves-light float-right`}
    >
      <i className={`${props.icon} label-icon align-middle fs-16 ms-2`} />{" "}
      {props.text}
    </button>
  );
};
const SubmitButton = React.memo((props) => {
  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };
  // props.loading => Used for show loading
  // props.loadingMessage => Used for show message text while loading
  // props.type => Used for set color of button
  // props.otherClasses  => Used for add other css classes
  return props.loading === true ? (
    <button type="button" className={`btn btn-${props.type} ${props.loadingClasses} btn-load`}>
      <span className="d-flex align-items-center">
        {/* props.loadingCss => this us used for add external css classes to make adjust size of loader */}
        <span class={`spinner-border flex-shrink-0 ${props.loadingCss} `} role="status">
          <span class="visually-hidden">{props.loadingMessage}...</span>
        </span>
        <span className="flex-grow-1 me-2 ps-1">{props.loadingMessage}...</span>
      </span>
    </button>
  ) : (
    <button
      type="submit"
      disabled={props.disabled}
      className={`btn btn-${props.type} ${props.otherClasses} btn-label waves-effect ${props.iconSide} waves-light float-${props.float}`}
      onClick={handleClick}
    >
      <i className={`${props.icon} label-icon align-middle fs-16`} />
      <span className="flex-grow-1 me-2">{props.buttonName}</span>
    </button>
  );
});
const IconButton = React.memo((props) => {
  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };

  return props.tooltipName && props.tooltipPosition ?
    (
      <TooltipComponent name={props.tooltipName} position={props.tooltipPosition}>
      <button
        disabled={props.disabled}
        onClick={()=> {if(!props.loading) handleClick();}}
        type="button"
        className={`btn-icon btn btn-sm btn-outline-${props.type}`}
      >
        {props.loading ? (
          <span class="spinner-border flex-shrink-0 smallLoader" role="status">
            <span class="visually-hidden">
              Loading...
            </span>
          </span>
        ) : (
          <i className={props.icon}></i>
        )}
      </button>
      </TooltipComponent>
    ):
    (
      <button
        disabled={props.disabled}
        onClick={()=> {if(!props.loading) handleClick();}}
        type="button"
        className={`btn-icon btn btn-sm btn-outline-${props.type}`}
      >
        {props.loading ? (
          <span class="spinner-border flex-shrink-0 smallLoader" role="status">
            <span class="visually-hidden">
              Loading...
            </span>
          </span>
        ) : (
          <i className={props.icon}></i>
        )}
      </button>
  )
});


// const formatDate = (GettedDate) => {
//   if (!GettedDate) {
//     return ``;
//   }

//   const date = new Date(GettedDate);
//   // if (isNaN(date.getTime())) {
//   //   throw new Error("Invalid date format");
//   // }

//   // Array of month names
//   const monthNames = [
//     "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
//   ];

//   // Get the day, month, and year
//   const day = date.getDate();
//   const month = monthNames[date.getMonth()];
//   const year = date.getFullYear();

//   // Return the formatted date string, with padded day
//   return `${day.toString().padStart(2, '0')}-${month}-${year}`;
// }

const formatDate = (GettedDate) => {
  if (!GettedDate) {
    return ``;
  }

  if (GettedDate instanceof Date && !isNaN(GettedDate.getTime())) {
    return formatValidDate(GettedDate);
  }

  let date;

  if (typeof GettedDate === "string" && GettedDate.includes(" ")) {
    GettedDate = GettedDate.split(" ")[0]; 
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(GettedDate)) {
    date = new Date(GettedDate);
  } 

  else if (/^\d{2}-\d{2}-\d{4}$/.test(GettedDate)) {
    const [day, month, year] = GettedDate.split("-").map(Number);
    date = new Date(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);
  }

  if (date instanceof Date && !isNaN(date.getTime())) {
    return formatValidDate(date);
  }

  return ``; 
};

const formatValidDate = (date) => {
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day.toString().padStart(2, '0')}-${month}-${year}`;
};

const formatTime = (datetimeString) => {
  if (!datetimeString) {
    return "";
  }
  var timeString = datetimeString.split(' ')[1];
  var timeComponents = timeString.split(':');
  var hours = parseInt(timeComponents[0]);
  var minutes = parseInt(timeComponents[1]);
  var meridiem = (hours < 12) ? 'AM' : 'PM';
  hours = (hours % 12 === 0) ? 12 : hours % 12;
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  var formattedTime = hours + ':' + minutes + ' ' + meridiem;

  return formattedTime;
}

const convertTo12HourFormat = (datetimeString) => {
  if (!datetimeString) {
    return "";
  }

  var timeComponents = datetimeString.split(':');
  var hours = parseInt(timeComponents[0]);
  var minutes = parseInt(timeComponents[1]);
  var meridiem = (hours < 12) ? 'AM' : 'PM';
  hours = (hours % 12 === 0) ? 12 : hours % 12;
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  var formattedTime = hours + ':' + minutes + ' ' + meridiem;

  return formattedTime;
}


// function getHoursAndMinutes(timeString) {
//   if (!timeString) {
//     return "";
//   }

//   const timeParts = timeString.split(':');
//   let hours = parseInt(timeParts[0], 10);
//   const minutes = timeParts[1];

//   if (hours < 0) {
//     hours = '-' + Math.abs(hours);
//   }

//   return `${hours}h ${minutes}m`;
// }
function getHoursAndMinutes(timeString) {
  if (!timeString) {
      return "";
  }

  const isNegative = timeString.startsWith('-');
  const timeParts = timeString.replace('-', '').split(':'); 

  let hours = parseInt(timeParts[0], 10);
  let minutes = parseInt(timeParts[1], 10);
  let seconds = parseFloat(timeParts[2]); 

  if (hours === 0 && minutes === 0 && seconds > 0) {
      return `0h 00m`;
  }

  return `${isNegative ? '-' : ''}${hours}h ${minutes.toString().padStart(2, '0')}m`;
}


// function isNegativeDeviation(deviation) {
//   if (!deviation) {
//     return ' '
//   }
//   const deviationParts = deviation.split(' ');
//   const hours = parseInt(deviationParts[0]) || 0;
//   const minutes = parseInt(deviationParts[2]) || 0;
//   const totalMinutes = hours * 60 + minutes;
//   return totalMinutes < 0;
// }
function isNegativeDeviation(deviation) {
  if (!deviation) {
      return false;
  }

  // Check if the deviation starts with a negative sign
  const isNegative = deviation.startsWith('-');

  return isNegative;
}

function getDaysDifference(date) {
  const date1 = new Date(date);
  const date2 = new Date();

  const timeDifference = date2.getTime() - date1.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference;
}


const IsRequired = () => {
  return (
    <span style={{ color: 'blue', marginLeft: 5, borderRadius: '50%', background: 'rgb(240, 248, 255)', textAlign: 'center', width: 20, height: 20, padding: '0px 5px' }}>*</span>
  );
}

// not working as expected, the result in frontend is skipping every 2nd row
function formatDateTime_NOTINUSE(input_timeStamp) {

  if (!input_timeStamp) {
    return ''
  }

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Parse the input_timeStamp date string into a Date object
  const dateObj = new Date(input_timeStamp);

  // Extract individual components
  const day = String(dateObj.getDate()).padStart(2, '0'); // Day of the month (2 digits)
  const month = months[dateObj.getMonth()]; // Month name (short form)
  const year = dateObj.getFullYear(); // Full year
  let hours = dateObj.getHours(); // Hours (24-hour format)
  const minutes = String(dateObj.getMinutes()).padStart(2, '0'); // Minutes (2 digits)

  // Determine AM/PM
  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format

  // Format the final string
  return `${day}-${month}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${amPm}`;
}

function formatDateTime(input_datetime) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Split the input_datetime into date and time parts
  const [datePart, timePart] = input_datetime.split(" ");
  const [year, month, day] = datePart.split("-");
  const [hours, minutes] = timePart.split(":");

  // Convert 24-hour time to 12-hour time
  const hour = parseInt(hours, 10);
  const amPm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight

  // Return the formatted string
  return `${day}-${months[parseInt(month, 10) - 1]}-${year} ${String(formattedHour).padStart(2, '0')}:${minutes} ${amPm}`;
}

export { TextBox, IsRequired, TextArea, SubmitBtn,SubmitButton,IconButton, formatDate, formatTime, convertTo12HourFormat, getHoursAndMinutes, isNegativeDeviation, getDaysDifference, formatDateTime };